import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const Alerts = ({ alerts, devices }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [alertType, setAlertType] = useState("");
  const [selectedDevice, setSelectedDevice] = useState("");
  const [filteredAlerts, setFilteredAlerts] = useState(alerts);

  useEffect(() => {
    setFilteredAlerts(alerts); // Update table in real-time
  }, [alerts]);

  const applyFilters = () => {
    let data = alerts;

    if (alertType) {
      data = data.filter((a) => a.type === alertType);
    }
    if (selectedDevice) {
      data = data.filter((a) => a.device_id === parseInt(selectedDevice));
    }
    if (startDate && endDate) {
      data = data.filter((a) => {
        const alertTime = new Date(a.datetime).getTime();
        return (
          alertTime >= startDate.toDate().getTime() &&
          alertTime <= endDate.toDate().getTime()
        );
      });
    }

    setFilteredAlerts(data);
  };

  const clearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setAlertType("");
    setSelectedDevice("");
    setFilteredAlerts(alerts);
  };

  const exportCSV = () => {
    const csv = Papa.unparse(filteredAlerts);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "alerts.csv");
  };

  const columns = [
    { name: "Type", selector: (row) => row.type, sortable: true },
    { name: "Device", selector: (row) => row.device_name || "N/A", sortable: true },
    { name: "Message", selector: (row) => row.message, sortable: true },
    { name: "DateTime", selector: (row) => row.datetime, sortable: true },
  ];

  const customStyles = {
    table: { style: { backgroundColor: "#1f2937", color: "#fff" } },
    headCells: { style: { backgroundColor: "#374151", color: "#fff" } },
    rows: { style: { backgroundColor: "#1f2937", color: "#fff" } },
    pagination: { style: { backgroundColor: "#1f2937", color: "#fff" } },
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Alerts</h1>

      {/* Filters */}
      <div className="flex flex-wrap items-end gap-4 mb-4">
        {/* Start Date */}
        <div>
          <label className="block mb-1 text-sm">Start DateTime</label>
          <Datetime
            value={startDate}
            onChange={(val) => setStartDate(val)}
            inputProps={{
              className: "bg-gray-800 text-white p-2 rounded w-48",
            }}
          />
        </div>

        {/* End Date */}
        <div>
          <label className="block mb-1 text-sm">End DateTime</label>
          <Datetime
            value={endDate}
            onChange={(val) => setEndDate(val)}
            inputProps={{
              className: "bg-gray-800 text-white p-2 rounded w-48",
            }}
          />
        </div>

        {/* Alert Type */}
        <div>
          <label className="block mb-1 text-sm">Alert Type</label>
          <select
            value={alertType}
            onChange={(e) => setAlertType(e.target.value)}
            className="bg-gray-800 text-white p-2 rounded w-40"
          >
            <option value="">All</option>
            <option value="Critical">Critical</option>
            <option value="Warning">Warning</option>
            <option value="Info">Info</option>
          </select>
        </div>

        {/* Device Filter */}
        <div>
          <label className="block mb-1 text-sm">Device</label>
          <select
            value={selectedDevice}
            onChange={(e) => setSelectedDevice(e.target.value)}
            className="bg-gray-800 text-white p-2 rounded w-44"
          >
            <option value="">All Devices</option>
            {devices.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
        </div>

        {/* Buttons */}
        <div className="flex gap-2">
          <button
            onClick={applyFilters}
            className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
          >
            Search
          </button>
          <button
            onClick={clearFilters}
            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded"
          >
            Clear
          </button>
        </div>

        {/* Export */}
        <div className="ml-auto">
          <button
            onClick={exportCSV}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
          >
            Export CSV
          </button>
        </div>
      </div>

      {/* Data Table */}
      <DataTable
        columns={columns}
        data={filteredAlerts}
        pagination
        highlightOnHover
        customStyles={customStyles}
      />
    </div>
  );
};

export default Alerts;
